const bosqueBambu = {
  id: "bosque-bambu",
  displayName: "Bosque de Bambú",

  atmosphere: {
    sky: "#0d1f1e",
    fog: { near: 18, far: 75 },
    exposure: 1.15,
    stars: { count: 400, color: "#c8ded4", size: 1.2 },
    hemisphereLight: { sky: "#2a5248", ground: "#0d1a16", intensity: 0.65 },
    moon: {
      color: "#cfe8d8",
      intensity: 0.7,
      position: [22, 36, -20],
      shadowMapSize: 2048,
      shadowBias: -0.0004,
      shadowMargin: 12,
    },
  },

  materials: {
    ground: { color: "#1d3b32", roughness: 1 },
    hedge: { color: "#173028", roughness: 1 },
    stone: { color: "#4a5a66", roughness: 0.9 },
    stoneDark: { color: "#39464f", roughness: 0.95 },
    rock: { color: "#48585e", roughness: 1, flatShading: true },
    wood: { color: "#54422f", roughness: 0.85 },
    bamboo: { color: "#3f6b4f", roughness: 0.7 },
    water: { color: "#123c4a", roughness: 0.2, emissive: "#0a2833", emissiveIntensity: 0.35 },
    lanternWindow: { color: "#2e5548", roughness: 0.6 },
    lanternGlow: "#7dffd4",
  },

  arena: {
    floorRadius: 32,
    floorSegments: 56,
    halfExtent: 28,
    wallHeight: 4,
    wallThickness: 1.6,
    cornerPost: { size: [2, 4.4, 2] },
  },

  spawns: {
    players: [
      [0, 0.5, -24],
      [0, 0.5, 24],
      [-24, 0.5, 0],
      [24, 0.5, 0],
    ],
    waypoints: [
      [18, 0, 0],
      [-18, 0, 0],
      [0, 0, 18],
      [0, 0, -18],
      [13, 0, 13],
      [-13, 0, 13],
      [13, 0, -13],
      [-13, 0, -13],
      [23, 0, 10],
      [-23, 0, -10],
      [10, 0, -22],
      [-10, 0, 22],
    ],
  },

  entities: [
    {
      type: "platform",
      position: [0, 0.06, 0],
      radiusTop: 7,
      radiusBottom: 7.4,
      height: 0.12,
      material: "water",
    },

    {
      type: "rock",
      position: [0, 0.45, 0],
      scale: [1.9, 1.3, 1.9],
      rotationY: 0.9,
      material: "rock",
    },
    {
      type: "rock",
      position: [2.6, 0.25, 1.8],
      scale: [1.2, 0.8, 1.3],
      rotationY: -0.5,
      material: "rock",
    },
    {
      type: "rock",
      position: [-2.4, 0.2, -2],
      scale: [1.1, 0.7, 1.2],
      rotationY: 2.2,
      material: "rock",
    },

    { type: "lantern", position: [9, 0, 9] },
    { type: "lantern", position: [-9, 0, 9] },
    { type: "lantern", position: [9, 0, -9] },
    { type: "lantern", position: [-9, 0, -9] },
    { type: "lantern", position: [0, 0, 25], baseWidth: 1, lightDistance: 18 },
    { type: "lantern", position: [0, 0, -25], baseWidth: 1, lightDistance: 18 },

    {
      type: "column", position: [6.2, 3, 16.4], radius: 0.18, height: 6, material: "bamboo"
    },
    {
      type: "column", position: [7.6, 2.6, 15.2], radius: 0.14, height: 5.2, material: "bamboo"
    },
    {
      type: "column", position: [5, 2.8, 15], radius: 0.16, height: 5.6, material: "bamboo"
    },

    {
      type: "column", position: [-6.2, 3, -16.4], radius: 0.18, height: 6, material: "bamboo"
    },
    {
      type: "column", position: [-7.6, 2.6, -15.2], radius: 0.14, height: 5.2, material: "bamboo"
    },
    {
      type: "column", position: [-5, 2.8, -15], radius: 0.16, height: 5.6, material: "bamboo"
    },

    {
      type: "column", position: [16.4, 3, -6.2], radius: 0.18, height: 6, material: "bamboo"
    },
    {
      type: "column", position: [15.2, 2.6, -7.6], radius: 0.14, height: 5.2, material: "bamboo"
    },
    {
      type: "column", position: [15, 2.8, -5], radius: 0.16, height: 5.6, material: "bamboo"
    },

    {
      type: "column", position: [-16.4, 3, 6.2], radius: 0.18, height: 6, material: "bamboo"
    },
    {
      type: "column", position: [-15.2, 2.6, 7.6], radius: 0.14, height: 5.2, material: "bamboo"
    },
    {
      type: "column", position: [-15, 2.8, 5], radius: 0.16, height: 5.6, material: "bamboo"
    },

    {
      type: "column", position: [19.5, 3.2, 19], radius: 0.2, height: 6.4, material: "bamboo"
    },
    {
      type: "column", position: [21, 2.7, 17.8], radius: 0.15, height: 5.4, material: "bamboo"
    },
    {
      type: "column", position: [18.2, 2.9, 20.4], radius: 0.17, height: 5.8, material: "bamboo"
    },

    {
      type: "column", position: [-19.5, 3.2, -19], radius: 0.2, height: 6.4, material: "bamboo"
    },
    {
      type: "column", position: [-21, 2.7, -17.8], radius: 0.15, height: 5.4, material: "bamboo"
    },
    {
      type: "column", position: [-18.2, 2.9, -20.4], radius: 0.17, height: 5.8, material: "bamboo"
    },

    {
      type: "column", position: [21.5, 2.8, -17], radius: 0.16, height: 5.6, material: "bamboo"
    },
    {
      type: "column", position: [20.2, 3, -18.5], radius: 0.18, height: 6, material: "bamboo"
    },

    {
      type: "column", position: [-21.5, 2.8, 17], radius: 0.16, height: 5.6, material: "bamboo"
    },
    {
      type: "column", position: [-20.2, 3, 18.5], radius: 0.18, height: 6, material: "bamboo"
    },

    { type: "box", size: [1.2, 1.2, 1.2], position: [3.2, 0.6, -12], rotationY: 0.3, material: "wood" },
    { type: "box", size: [1.2, 1.2, 1.2], position: [-3.2, 0.6, 12], rotationY: -0.2, material: "wood" },
    { type: "box", size: [1.4, 1.4, 1.4], position: [12, 0.7, 3.4], rotationY: 0.5, material: "wood" },
    {
      type: "box",
      size: [1.4, 1.4, 1.4],
      position: [-12, 0.7, -3.4],
      rotationY: -0.4,
      material: "wood",
    },

    {
      type: "rock",
      position: [11, 0.35, -11],
      scale: [1.5, 1, 1.6],
      rotationY: 1.2,
      material: "rock",
    },
    {
      type: "rock",
      position: [-11, 0.35, 11],
      scale: [1.5, 1, 1.6],
      rotationY: 0.4,
      material: "rock",
    },
  ],
};

export default bosqueBambu;
